import { resolvePermissionsForRoles } from './role-permissions.js';

export interface OidcClaimsLike {
  readonly sub?: string;
  readonly email?: string;
  readonly name?: string;
  readonly preferred_username?: string;
  readonly organization_id?: string;
  readonly scope?: string;
  readonly scp?: readonly string[];
  readonly permissions?: readonly string[];
  readonly realm_access?: { readonly roles?: readonly string[] };
  readonly resource_access?: Record<string, { readonly roles?: readonly string[] }>;
  readonly authorization?: {
    readonly permissions?: readonly string[];
  };
}

export function extractOidcRealmRoles(claims: OidcClaimsLike): string[] {
  return [...(claims.realm_access?.roles ?? [])];
}

export function extractOidcClientRoles(claims: OidcClaimsLike, clientId?: string): string[] {
  if (!clientId) {
    return [];
  }

  return [...(claims.resource_access?.[clientId]?.roles ?? [])];
}

export function extractOidcRoles(claims: OidcClaimsLike, clientId?: string): string[] {
  return [...new Set([...extractOidcRealmRoles(claims), ...extractOidcClientRoles(claims, clientId)])];
}

export function extractOidcScopes(claims: OidcClaimsLike): string[] {
  const scopeValues = claims.scope ? claims.scope.split(' ').filter(Boolean) : [];
  const scpValues = claims.scp ? [...claims.scp] : [];
  return [...new Set([...scopeValues, ...scpValues])];
}

export function extractOidcPermissions(claims: OidcClaimsLike, clientId?: string): string[] {
  const directPermissions = [
    ...(claims.permissions ?? []),
    ...(claims.authorization?.permissions ?? []),
  ];

  if (directPermissions.length > 0) {
    return [...new Set(directPermissions)];
  }

  return resolvePermissionsForRoles(extractOidcRoles(claims, clientId));
}
